let cachedApiUrl: string | null = null;

export const fetchApiUrl = async (): Promise<string | null> => {
    if (cachedApiUrl) return cachedApiUrl;
    try {
        const response = await fetch("/env.json");
        if (!response.ok) {
            throw new Error("Failed to fetch API URL");
        }
        const json = await response.json();
        cachedApiUrl = json.apiUrl;
        return cachedApiUrl;
    } catch (error) {
        console.error("Error fetching API URL:", error);
        throw new Error("API URL could not be determined.");
    }
};
